import { Suspense } from 'react';
import { Outlet } from 'react-router';
import { Providers } from './providers';
import PushRegister from '@/components/PushRegister';
import AppInstallBanner from '@/components/AppInstallBanner';

export default function RootLayout() {
  return (
    <Providers>
      <PushRegister />
      <AppInstallBanner />
      <Suspense
        fallback={
          <div className='flex items-center justify-center h-screen'>
            <div className='text-center'>Loading...</div>
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </Providers>
  );
}
